// extracted by mini-css-extract-plugin
module.exports = {"listPlacesTableContainer":"listPlacesTableContainer--9af7f"};